var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.5C10.5 2.672 11.172 2 12 2C12.828 2 13.5 2.672 13.5 3.5V4.19531C14.2348 4.38471 14.9152 4.70933 15.5129 5.14113C14.7864 5.35428 14.158 5.79669 13.7113 6.38469C13.1923 6.13807 12.612 6 12 6C9.794 6 8 7.794 8 10V15.1716C8 15.702 7.78929 16.2107 7.41421 16.5858L7 17H17L16.5858 16.5858C16.2107 16.2107 16 15.702 16 15.1716V11.9646C16.1633 11.9879 16.3302 12 16.5 12C17.0368 12 17.5454 11.8792 18 11.6632V15.1716C18 15.702 18.2107 16.2107 18.5858 16.5858L19.7929 17.7929C19.9255 17.9255 20 18.1054 20 18.2929C20 18.6834 19.6834 19 19.2929 19H13.7285C13.9053 19.3037 13.9989 19.6486 14 20C14 20.5304 13.7893 21.0391 13.4142 21.4142C13.0391 21.7893 12.5304 22 12 22C11.4696 22 10.9609 21.7893 10.5858 21.4142C10.2107 21.0391 10 20.5304 10 20C10.0005 19.6488 10.0934 19.3039 10.2695 19H4.70711C4.31658 19 4 18.6834 4 18.2929C4 18.1054 4.0745 17.9255 4.20711 17.7929L5.41421 16.5858C5.78929 16.2107 6 15.702 6 15.1716V10C6 7.2048 7.91318 4.86209 10.5 4.19531V3.5Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 8.5,
    r: 2.5,
    fill: "url(#paint0_linear_1260_10274)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1260_10274",
    x1: 17.9028,
    y1: 6.36111,
    x2: 13.7778,
    y2: 10.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2400FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC10D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.a8a85a919501644da9eee7cd61240713.svg";
export { ForwardRef as ReactComponent };